import Aqumen from "@aqumen/sdk";
import React, {useState} from "react";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";

import {blurOnEnter} from "@/library/utility/blur_on_enter.js";

export function UserFullNameTile(props) {
  const intl = useIntl();

  const session = useSelector(s => s.accessControlSession);
  const [fullName, setFullName] = useState(props.user.fullName ?? "");

  const submit = (value) => {
    Aqumen.User.update(session, {id: props.user.id}, {fullName: value});
  };
  const debouncedSubmit = useDebouncedCallback(submit, 1000);

  const handleChange = (event) => {
    setFullName(event.target.value);
    debouncedSubmit(event.target.value);
  };

  const handleBlur = (event) => {
    debouncedSubmit.cancel();
    if (event.target.value !== props.user.fullName) {
      return submit(event.target.value);
    }
  };

  const disabled = Boolean(props.user.archivedAt);
  return (
    <div className="user-full-name-tile">
      <label className="user-full-name label">
        <span className="user-full-name label-text">
          {intl.formatMessage({id: props.i18nPrefix + ".fullName.label"})}
        </span>
        <input className="user-full-name"
               type="text"
               disabled={disabled}
               value={fullName}
               onBlur={handleBlur}
               onChange={handleChange}
               onKeyUp={blurOnEnter}/>
      </label>
    </div>
  );
}
